module.exports = __webpack_public_path__ + "static/media/stamp-on-red.d6c1346d.webp";